import round from "../number/round";

export default function (weight: number | undefined, precision = 0) {
  if (weight === undefined) return undefined;
  return round(weight * 2.20462, precision) ?? weight * 2.20462;
}
